module.exports = __webpack_public_path__ + "img/result-oman-01.0e454f75.svg";